/*eslint-disable*/
import api from '../'

class TransactionsApi {
  // GET: records
  static list(params, cancelToken = null) {
    return api.axios.get('/school-transactions', {params, cancelToken})
    .then(response => response.data)
  }

  static exportList(params) {
    return api.axios.get('/school-transactions/export', {params})
    .then(response => response.data)
  }
}

export default TransactionsApi;
